import {
  Box,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@mui/material';
import React from 'react';
import { NumericFormat } from 'react-number-format';
import { ILegalTransactionRelationshipRealEstate } from '../../../Interfaces/ILegalTransactionRelationship/ILegalTransactionRelationshipRealEstate/ILegalTransactionRelationshipRealEstate';
import { IRealEstateUseType } from '../../../Interfaces/IRealEstateUseType';

interface IProps {
  formValues: ILegalTransactionRelationshipRealEstate;
  setFormValues: React.Dispatch<
    React.SetStateAction<ILegalTransactionRelationshipRealEstate>
  >;
  realEstateUseTypes: IRealEstateUseType[];
  setIsWarningPrice: React.Dispatch<React.SetStateAction<boolean>>;
  isWarningPrice: boolean;
}

export const RealEstatePriceUseType: React.FC<IProps> = ({
  formValues: {
    Price,
    PriceInventoryOption,
    idRealEstateUseType,
    Defect,
    Particularities,
    InventoryOptionArray,
  },
  setFormValues,
  realEstateUseTypes,
  setIsWarningPrice,
  isWarningPrice,
}) => (
  <>
    <Typography variant='h5' sx={{ mt: 2, mb: 1 }}>
      Nutzung
      <br />
      <Typography>
        Falls Sie die Informationen über den Grundbucheintrag Ihres
        Vertragsgegenstandes haben, so tragen Sie diese bitte ein. Sofern Sie
        diese Informationen nicht vorliegen haben, ist dies kein Problem. Die
        Informationen können nachgereicht oder durch unsere Mitarbeiter im
        Grundbuch geprüft werden.
      </Typography>
    </Typography>
    <Box sx={{ mt: 5 }} />
    <Grid container spacing={2}>
      <Grid item sm={6}>
        <NumericFormat
          value={Price}
          suffix=' €'
          fixedDecimalScale
          thousandsGroupStyle='thousand'
          thousandSeparator='.'
          decimalSeparator=','
          fullWidth
          customInput={TextField}
          onValueChange={(values, _) => {
            if (values.floatValue !== undefined) {
              setIsWarningPrice(false);
              setFormValues(x => ({
                ...x,
                Price: values.floatValue ?? 0,
              }));
            } else {
              setIsWarningPrice(true);
            }
          }}
          allowNegative={false}
          label='Kaufpreis'
          size='small'
          error={isWarningPrice}
        />
      </Grid>

      <Grid item sm={6}>
        <NumericFormat
          value={PriceInventoryOption}
          suffix=' €'
          fixedDecimalScale
          thousandsGroupStyle='thousand'
          thousandSeparator='.'
          decimalSeparator=','
          fullWidth
          customInput={TextField}
          onValueChange={(values, _) => {
            if (values.floatValue !== undefined) {
              setFormValues(x => ({
                ...x,
                PriceInventoryOption: values.floatValue ?? null,
              }));
            } else {
              setFormValues(x => ({
                ...x,
                PriceInventoryOption: null,
              }));
            }
          }}
          allowNegative={false}
          label='Anteil der Anlagen vom Kaufpreis'
          size='small'
          disabled={InventoryOptionArray.length === 0}
        />
      </Grid>

      <Grid item sm={12}>
        <FormControl fullWidth size='small' required>
          <InputLabel>Nutzungsüberlassung</InputLabel>
          <Select
            value={idRealEstateUseType}
            label='Nutzungsüberlassung'
            onChange={({ target: { value } }) =>
              setFormValues(x => ({
                ...x,
                idRealEstateUseType: Number(value),
              }))
            }
          >
            {realEstateUseTypes.map((x, i) => (
              <MenuItem key={i} value={x.idRealEstateUseType}>
                {x.RealEstateUseType}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>

      <Grid item sm={12}>
        <TextField
          label='Mängel / Einschränkungen der Nutzbarkeit'
          size='small'
          fullWidth
          value={Defect ?? ''}
          onChange={({ target }: React.ChangeEvent<HTMLInputElement>) =>
            setFormValues(x => ({
              ...x,
              Defect: target.value || null,
            }))
          }
          multiline
          rows={3}
        />
      </Grid>

      <Grid item sm={12}>
        <TextField
          label='Besonderheiten'
          size='small'
          fullWidth
          value={Particularities ?? ''}
          onChange={({ target }: React.ChangeEvent<HTMLInputElement>) =>
            setFormValues(x => ({
              ...x,
              Particularities: target.value || null,
            }))
          }
          multiline
          rows={3}
        />
      </Grid>
    </Grid>
  </>
);
